import { Box, CardMedia, Divider, Typography, useTheme } from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIos"
import { useTranslation } from "providers/i18n"
import { useMemo } from "react"
import { getIcon } from "utils/icon"

export const DirectionSummary = ({
  duration,
  distance,
  originName,
  destinationName,
  originVenueLogo,
  destinationVenueLogo,
}) => {
  const theme = useTheme()
  const {
    directionSummaryContainer,
    locationSummaryContainer,
    locationContainer,
    venueLogoContainer,
    venueLogo,
    durationText,
    distanceText,
    divider,
    locationText,
    directionSummaryArrowContainer,
    startText,
  } = theme.components[`AppDirectionOverview`]?.styleOverrides || {}
  const { t } = useTranslation()

  const isRtl = theme.direction === "rtl"

  const ArrowIcon = useMemo(
    () => getIcon(theme?.assets?.nextIcon) || <ArrowForwardIcon />,
    [theme]
  )

  return (
    <Box sx={directionSummaryContainer}>
      <Typography sx={durationText}>
        {t("Travel Duration", { duration })}
      </Typography>
      <Typography sx={distanceText}>
        {t("Travel Distance", { distance })}
      </Typography>
      <Divider sx={divider} />
      <Box sx={locationSummaryContainer}>
        <Box sx={locationContainer}>
          <Typography sx={startText}>{t("from")}</Typography>
          <Box sx={venueLogoContainer}>
            <CardMedia image={originVenueLogo} sx={venueLogo} />
          </Box>
          <Typography variant="body2" sx={locationText}>
            {t(originName)}
          </Typography>
        </Box>
        <Box
          className={isRtl ? "is-rtl" : ""}
          sx={directionSummaryArrowContainer}
        >
          {ArrowIcon}
        </Box>
        <Box sx={locationContainer}>
          <Box sx={venueLogoContainer}>
            <CardMedia image={destinationVenueLogo} sx={venueLogo} />
          </Box>
          <Typography variant="body2" sx={locationText}>
            {t(destinationName)}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
